import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { SettingsContext } from "../../store/Settings.store";
import actions from "../../store/Settings.actions";
import { updateUser } from "../../../../services/api/auth.api";
import {
  Field,
  PhoneField,
} from "../../../../container/Auth/common/Field/Field";
import { Modal } from "react-bootstrap";
import { changePassword } from "../../../../services/api/auth.api";
import { FormattedMessage, injectIntl } from "react-intl";

function NewPasswordModal(props) {
  const [error, setError] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const passwordRef = useRef(null);

  const handleOnSubmit = async (e) => {
    setError("");
    e.preventDefault();
    if (!passwordRef.current.checkValidity()) {
      return;
    }
    if (newPassword !== confirmPassword) {
      setError(
        props.intl.formatMessage({ id: "auth.pleaseConfirmYourNewPassword" })
      );
      return;
    }
    let { data, statusCode } = await changePassword({
      newPassword,
      currentPassword,
    });
    if (statusCode === 200) {
      props.toggleShowPasswordModal();
    } else setError(data.messageTranslated || data.message);
  };
  return (
    <Modal
      show={props.showPasswordModal}
      onHide={props.toggleShowPasswordModal}
      className="fade add-member-wrapper  addmember-modal"
    >
      <Modal.Header className="modal-header border-0" closeButton>
        <h5 className="heading mb-8">
          {" "}
          <FormattedMessage id={"info.newPassword"} />
        </h5>
      </Modal.Header>
      <form onSubmit={handleOnSubmit} className="form-inner-content">
        <div className="modal-body p-10">
          <div className="form-blocks">
            <Field
              label={<FormattedMessage id={"info.currentPassword"} />}
              onChange={setCurrentPassword}
              type={"password"}
              hideCheck
              hideCheckIcon
            />
            <Field
              label={<FormattedMessage id={"info.newPassword"} />}
              onChange={setNewPassword}
              type={"password"}
              passwordRef={passwordRef}
            />
            {/*  <Field
              label={"Confirm Password"}
              onChange={setNewPassword}
              type={"password"}
            />*/}
            <div
              className={
                "floating-effect  form-group " +
                (confirmPassword && newPassword === confirmPassword
                  ? "success"
                  : "")
              }
            >
              <input
                type={"password"}
                placeholder={" "}
                onChange={(e) => setConfirmPassword(e.target.value)}
                value={confirmPassword}
                required
              />
              <label>
                <FormattedMessage id={"info.confirmPassword"} />
              </label>
              {passwordRef &&
                passwordRef.current &&
                passwordRef.current.checkValidity() &&
                newPassword === confirmPassword && (
                  <span className="checked-icon">
                    <img src="/assets/images/ic-checked.svg" alt="" />
                  </span>
                )}
            </div>
          </div>
        </div>
      </form>
      {error && (
        <div
          className="text-center  error  kaspr-form-text-error"
          style={{ top: 0, width: "90%" }}
        >
          {error + " "}
        </div>
      )}
      <div className="modal-footer border-0">
        <a
          href="#"
          className="btn1 btn48"
          onClick={handleOnSubmit}
          type={"submit"}
        >
          <FormattedMessage id={"info.changePassword"} />
        </a>
      </div>
    </Modal>
  );
}
NewPasswordModal = injectIntl(NewPasswordModal);
export default function EditProfile(props) {
  const { state, dispatch } = useContext(SettingsContext);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [imageBase64, setImageBase64] = useState(false);
  const toggleShowPasswordModal = () =>
    setShowPasswordModal(!showPasswordModal);
  const handleToggle = useCallback(
    () =>
      dispatch({
        type: actions.EDIT_PROFILE_TOGGLE,
        payload: false,
      }),
    []
  );
  const updateInfos = async () => {
    const formData = new FormData();
    for (let field in state.editProfileForm) {
      if (field === "image") {
        formData.append("picture", state.editProfileForm[field]);
      } else if (field === "phone") {
        formData.append("phone", JSON.stringify(state.editProfileForm.phone));
      } else {
        formData.append(field, state.editProfileForm[field]);
      }
    }
    await updateUser(formData);
    window.location = "/settings";
  };

  const updateImage = async (e) => {
    let image = e.target.files[0];
    const acceptedImageTypes = [
      "image/gif",
      "image/jpeg",
      "image/png",
      "image/jpg",
    ];
    if (!(image && acceptedImageTypes.includes(image.type))) return;
    dispatch({ type: actions.EDIT_PROFILE, payload: { image } });
    let file = e.target.files[0],
      reader = new FileReader();

    reader.onloadend = function () {
      setImageBase64(reader.result);
    };

    reader.readAsDataURL(file);
  };

  useEffect(() => {
    setImageBase64(props.profile.image);
    dispatch({ type: actions.EDIT_PROFILE, payload: props.profile });
  }, []);

  return (
    <div className="tab-content">
      <div
        id="profile_tab"
        className={
          "tab-pane fade in " + (!props.goToIntegrations ? "active show" : "")
        }
      >
        <div className="content-box-ui">
          <div className="content-header p-16">
            <div className="title-ui">
              <label>
                <FormattedMessage id={"settings.profile.profile"} />
              </label>
            </div>
            <div className="button-ui">
              <button className="btn2  mr14" onClick={handleToggle}>
                <FormattedMessage id={"cancel"} />
              </button>
              <button className="btn1 ripple-btn" onClick={updateInfos}>
                <FormattedMessage id={"settings.profile.saveChanges"} />
              </button>
            </div>
          </div>

          <div className="body-content">
            <div className="inner-body-content edit-profile-ui">
              <div className="row">
                <div className="col-md-12">
                  <div className="profile-picture-ui">
                    <div className="title-ui">
                      {" "}
                      <FormattedMessage
                        id={"settings.profile.profilePicture"}
                      />
                    </div>
                    <div className="profile-ui">
                      <figure style={{ overflow: "hidden" }}>
                        <img
                          style={{ "max-width": "100%" }}
                          src={imageBase64 || "images/profile-placeholder.png"}
                          alt=""
                        />
                      </figure>
                      <label href="#" className="btn3 grey-btn" htmlFor="image">
                        <span className="plus-icon">+</span>
                        <input
                          type="file"
                          id="image"
                          style={{ display: "none" }}
                          className="btn3 grey-btn"
                          onChange={updateImage}
                        />
                        <FormattedMessage id={"settings.profile.addPicture"} />
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-xl-7 col-lg-10 col-md-12">
                  <div className="row">
                    <div className="col-md-6 col-sm-6">
                      <div className="floating-effect form-group capital">
                        <input
                          type="text"
                          className="grey-bg"
                          placeholder=" "
                          value={state.editProfileForm.firstName}
                          onChange={(e) =>
                            dispatch({
                              type: actions.EDIT_PROFILE,
                              payload: { firstName: e.target.value },
                            })
                          }
                          pattern="[A-Za-z]{3}"
                        />
                        <label>
                          {" "}
                          <FormattedMessage id={"info.firstName"} />{" "}
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-6">
                      <div className="floating-effect  form-group capital">
                        <input
                          type="text"
                          className=""
                          placeholder=" "
                          value={state.editProfileForm.lastName}
                          onChange={(e) =>
                            dispatch({
                              type: actions.EDIT_PROFILE,
                              payload: { lastName: e.target.value },
                            })
                          }
                          pattern="[A-Za-z]{3}"
                        />
                        <label>
                          <FormattedMessage id={"info.lastName"} />{" "}
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-6">
                      <div className="floating-effect  form-group capital">
                        <input
                          type="text"
                          className=""
                          placeholder=" "
                          value={state.editProfileForm.company}
                          onChange={(e) =>
                            dispatch({
                              type: actions.EDIT_PROFILE,
                              payload: { company: e.target.value },
                            })
                          }
                          pattern="[A-Za-z]{3}"
                        />
                        <label>
                          <FormattedMessage id={"info.company"} />
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-6">
                      <div className="floating-effect  form-group capital">
                        <input
                          type="text"
                          className=""
                          placeholder=" "
                          value={state.editProfileForm.title}
                          onChange={(e) =>
                            dispatch({
                              type: actions.EDIT_PROFILE,
                              payload: { title: e.target.value },
                            })
                          }
                          pattern="[A-Za-z]{3}"
                        />
                        <label>
                          <FormattedMessage id={"info.job"} />
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-6">
                      <PhoneField
                        onChange={(countryCode, phoneNumber, isValidPhone) => {
                          dispatch({
                            type: actions.EDIT_PROFILE,
                            payload: { phone: { phoneNumber, countryCode } },
                          });
                        }}
                        propsValue={
                          state.editProfileForm.phone.countryCode +
                          state.editProfileForm.phone.phoneNumber
                        }
                      />
                    </div>
                    <div className="col-md-6 col-sm-6">
                      <div className="input-summry">
                        <label>E-mail</label>
                        <p>{props.profile.email}</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-6">
                      <div className="input-summry edit-field">
                        <label>
                          <FormattedMessage id={"info.password"} />
                        </label>
                        <p>••••••••••••••••</p>
                        <a
                          href="#"
                          className="text-btn"
                          onClick={toggleShowPasswordModal}
                        >
                          <FormattedMessage id={"info.changePassword"} />
                        </a>
                        <NewPasswordModal
                          showPasswordModal={showPasswordModal}
                          toggleShowPasswordModal={toggleShowPasswordModal}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
